import { z } from 'zod'

// User schemas
export const userSchema = z.object({
  uid: z.string().min(1),
  email: z.string().email(),
  displayName: z.string().min(1).max(100),
  createdAt: z.date(),
})

export const loginSchema = z.object({
  email: z.string().email('Invalid email address'),
  password: z.string().min(6, 'Password must be at least 6 characters'),
})

export const signupSchema = z.object({
  email: z.string().email('Invalid email address'),
  password: z.string().min(6, 'Password must be at least 6 characters'),
  displayName: z.string().min(1, 'Name is required').max(100),
})

// Snippet schemas
export const snippetSchema = z.object({
  id: z.string(),
  userId: z.string(),
  content: z
    .string()
    .trim()
    .min(1, 'Content cannot be empty')
    .max(500, 'Content too long (max 500 characters)'),
  createdAt: z.date(),
  updatedAt: z.date(),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Invalid date format'),
  isDeleted: z.boolean(),
})

export const snippetInputSchema = z.object({
  content: z
    .string()
    .trim()
    .min(1, 'Content cannot be empty')
    .max(500, 'Content too long (max 500 characters)'),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Invalid date format'),
})

export const snippetUpdateSchema = z.object({
  content: z
    .string()
    .trim()
    .min(1, 'Content cannot be empty')
    .max(500, 'Content too long (max 500 characters)'),
})

// Infer types from schemas
export type UserData = z.infer<typeof userSchema>
export type LoginData = z.infer<typeof loginSchema>
export type SignupData = z.infer<typeof signupSchema>
export type SnippetData = z.infer<typeof snippetSchema>
export type SnippetInputData = z.infer<typeof snippetInputSchema>
export type SnippetUpdateData = z.infer<typeof snippetUpdateSchema>
